import { bool, object } from 'yup'

import { ActionType, PageName } from 'generated/types'
import { sendToSentry, transformErrors } from 'utils/errors'
import { FlowRoute } from 'utils/FlowProvider/types'
import { getGeneralError } from 'utils/getGeneralError'

export enum FormOptions {
  ROUNDUPS_ENABLED = 'roundupsEnabled',
}

export type FormValues = Record<FormOptions, boolean>

export const initialValues: FormValues = {
  [FormOptions.ROUNDUPS_ENABLED]: true,
}

export const validationSchema = object().shape({
  [FormOptions.ROUNDUPS_ENABLED]: bool().required(),
})

// Handles Formik's validate event.
export const validate = values => {
  let errors = {}

  try {
    validationSchema.validateSync(values, { abortEarly: false })
  } catch (validationErrors) {
    // Convert validation errors to Formik errors collection
    errors = transformErrors(validationErrors.inner)
  }

  return errors
}

export const formRows = [
  {
    name: FormOptions.ROUNDUPS_ENABLED,
    labelkey: 'roundups_setup.form.automatic',
    options: [
      {
        label: 'Automatic',
        subtext: 'We’ll invest the change from all purchases for you',
        value: true,
      },
      {
        label: 'Manual',
        subtext: "You'll need to choose which purchases create Rounds-Ups each time",
        value: false,
      },
    ],
  },
]

export const handleSubmit = ({
  closeErrorModal,
  route,
  showErrorModal,
  trackRoundupsSetupButtonTapped,
  updateRoundupsProfile,
  isDynamicFunnelEnabled,
  routeToPage,
}: any) => async (values: FormValues) => {
  trackRoundupsSetupButtonTapped(values.roundupsEnabled)
  try {
    const input = {
      roundUpsEnabled: values.roundupsEnabled,
    }

    await updateRoundupsProfile({ variables: input })
    isDynamicFunnelEnabled
      ? routeToPage(PageName.RoundUpsSetUp, ActionType.Continue)
      : route({ from: FlowRoute.RoundUpsSetup, action: 'continue' })
  } catch (error) {
    const retryHandler = () => {
      closeErrorModal()
    }
    const { title, message, actions, image } = getGeneralError(
      error,
      { closeErrorModal },
      retryHandler,
    )
    showErrorModal({ title, message, actions, image })

    sendToSentry(error)
  }
}
